import React from 'react';

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell";

export default function AggregateRating(options, params, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? gd.utils.roundToDecimals(props.value, 0) : null;

    let filledStars, emptyStars;
    if (isValid) {
        filledStars = value > 0 ? _.fill(Array(value), true) : [];
        const emptyNumber = params.ratingType - value;
        emptyStars = emptyNumber > 0 ? _.fill(Array(emptyNumber), false) : [];
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} {...props}>
            {isValid &&
            <div className="gd-field-rating list">
                <div className="field-holder">
                    {_.map(filledStars, (value,key)=><div key={key} className="i5-star"/>)}
                    {_.map(emptyStars, (value,key)=><div key={key} className="i5-star-empty"/>)}
                </div>
            </div>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{gd.const.aggregate.label[props.aggregateFunction]}</div>}
        </AggregateShellComponent>
    )
}